/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/25/22
 */

import React from "react";
import {Checkbox, FormControl, FormControlLabel, FormGroup} from "@mui/material";

export interface ConfigWhenProps {
	types: string[]
	onChange: (types: string[]) => void
	disabled?: boolean
}

export const onCalendarEventCreated = "calendar-event.created";
export const onCalendarEventUpdated = "calendar-event.updated";
export const onCalendarEventDeleted = "calendar-event.deleted";

export const typeLabels: Record<string, string> = {
	[onCalendarEventCreated]: "Calendar event is created",
	[onCalendarEventUpdated]: "Calendar event is updated",
	[onCalendarEventDeleted]: "Calendar event is deleted"
}

export default function ConfigWhen(props: ConfigWhenProps) {

	const onChange = (type: string, enabled: boolean) => {
		if (enabled) {
			props.onChange([ ...props.types, type ]);
		} else {
			props.onChange( props.types.filter(t => t !== type) );
		}
	}

	return (
		<FormControl>
			<FormGroup>
				{Object.keys(typeLabels).map(type =>
					<FormControlLabel
						key={type}
						control={
							<Checkbox
								checked={props.types.includes(type)}
								disabled={props.disabled}
								onChange={event => onChange(type, event.target.checked)}
								name={type}
							/>
						}
						label={typeLabels[type]}
					/>)
				}
			</FormGroup>
		</FormControl>
	);

}